<template>
  <div>
    <Loader></Loader>
    <v-card>
      <v-card-title class="black green--text mx-auto text-center" primary-title>
        {{selTable.toUpperCase()}}
        <v-spacer></v-spacer>
        <v-btn x-small dark rounded color="red darken-4">
          <v-icon @click="$emit('close-dialog')">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-layout row wrap class="px-2">
          <v-flex
            xs12
            md4
            v-for="(hdr,hief) in tblHeaders"
            :key="hief+Math.random()+Math.random()+Math.random()+Math.random()"
            class="px-1 my-2"
          >
            <v-datetime-picker
              v-if="hdr.includes('date_time')"
              :label="hdr.toUpperCase() +' ['+entryEditData[hdr]+']'"
              prepend-icon="mdi-calendar"
              v-model="entryEditData[hdr]"
              @input="formatDateTime"
            ></v-datetime-picker>

            <div v-else-if="hdr.includes('date') || hdr == 'start' || hdr == 'end'">
              <v-menu
                v-model="dateMenu[hdr]"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="entryEditData[hdr]"
                    :label="hdr.toUpperCase()"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :id="hdr"
                  v-model="entryEditData[hdr]"
                  @input="dateMenu[hdr] = false"
                  :value="entryEditData[hdr]"
                  full-width
                  :rules="[ rules.required]"
                  :landscape="$vuetify.breakpoint.smAndUp"
                  class="mt-4"
                  :label="''+ hdr | catifyHead"
                  @change="getSelectedValue(hdr)"
                ></v-date-picker>
              </v-menu>
            </div>

            <v-autocomplete
              v-else-if="selTable == 'live_lessons' && hdr == 'lead_educator'"
              :items="users"
              label="LEAD EDUCATOR"
              v-model="entryEditData[hdr]"
              @change="getSelectedValue(hdr)"
            ></v-autocomplete>

            <v-autocomplete
              v-else-if="selTable == 'live_lessons' && hdr == 'lesson_group'"
              :items="classes"
              label="LESSON GROUP"
              v-model="entryEditData[hdr]"
              @change="getSelectedValue(hdr)"
            ></v-autocomplete>

            <!-- <input
              v-else-if="hdr.includes('color')"
              :id="hdr"
              :placeholder="hdr"
              :value="entryEditData[hdr]"
              required
              type="color"
            />-->
            <v-color-picker
              v-else-if="hdr.includes('color')"
              :rules="[ rules.required]"
              v-model="entryEditData[hdr]"
              :label="''+ hdr | catifyHead"
              flat
              @change="getValue(hdr)"
            ></v-color-picker>

            <v-select
              v-else-if="hdr.includes('_id') && hdr.endsWith('_id')"
              :placeholder="entryEditData[hdr]+''"
              :rules="[ rules.required]"
              v-model="entryEditData[hdr]"
              :items="dropdownItems[hdr]"
              item-text="name"
              item-value="id"
              :label="''+ hdr | catifyHead"
              @change="getSelectedValue(hdr)"
            ></v-select>

            <!-- <v-file-input
              class="mt-5"
              v-else-if="hdr.includes('image') || hdr.includes('picture')"
              :id="hdr"
              :placeholder="fileLabel"
              :rules="[ rules.required]"
              show-size
              counter
              :label=" hdr | catifyHead"
              @change="setBase64Img(hdr)"
            ></v-file-input>-->

            <!--v-model="entryEditData[hdr]" omitted reason -> dont mutate props-->
            <!-- <v-select
              v-else-if="hdr.includes('_id') && hdr.endsWith('_id')"
              :placeholder="entryEditData[hdr]"
              :items="dropdownItems[hdr]"
              item-text="name"
              item-value="id"
              required
              :label="hdr"
              @change="setSelectValue(hdr)"
            ></v-select>-->

            <v-textarea
              v-else
              :rules="[ rules.required]"
              :id="hdr"
              rows="1"
              :label="''+ hdr | catifyHead"
              :placeholder="hdr | catifyHead"
              :value="entryEditData[hdr]"
              @focusout="getValue(hdr)"
            ></v-textarea>

            <!-- <v-textarea
              v-else
              :id="hdr"
              rows="1"
              required
              :placeholder="hdr"
              :value="entryEditData[hdr]"
            ></v-textarea>-->
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-btn dark rounded :color="btnColor" @click="saveFormData()">{{btnText}}</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import Loader from "@/components/Loader.vue";
import moment from "moment-timezone";

export default {
  components: { Loader },
  props: ["selTable", "entryEditData", "dropdownItems", "tblHeaders", "status"],
  updated() {
    this.formStatus = this.status;
    if (this.status == "edit") {
      this.btnText = "Save Changes";
    } else {
      this.btnText = "Save Data";
    }
  },
  mounted() {
    if (this.selTable == "live_lessons") {
      axios.getData("/auth/get-all-users", this.getAccessToken).then(users => {
        this.users = [];
        users.forEach(user => {
          this.users.push({
            text: user.name + " [" + user.email + "]",
            value: user.email
          });
        });
      });

      axios
        .getData("/auth/get-all-classes", this.getAccessToken)
        .then(classes => {
          this.classes = [];
          classes.forEach(classs => {
            this.classes.push({
              text: classs.class_name + " [" + classs.grade + "]",
              value: classs.class_name
            });
          });
        });
    }
  },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    }
  },
  data() {
    return {
      users: [],
      classes: [],
      dateTime: null,
      dateMenu: [],
      myFormData: {},
      selectData: {},
      ddObj: { id: "" },
      btnText: "Save Data",
      btnColor: "#3dc7be",
      images: {},
      formStatus: null,
      fileLabel: "Select File to Upload",

      date: new Date().toISOString().substr(0, 10),
      rules: {
        email: v => (v || "").match(/@/) || "Please enter a valid email",
        length: len => v =>
          (v || "").length >= len ||
          `Invalid character length, required ${len}`,
        password: v =>
          (v || "").match(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/
          ) ||
          "Password must contain an upper case letter, a numeric character, and a special character",
        required: v => !!v || "This field is required"
      }
    };
  },
  methods: {
    formatDateTime(dateTime) {
      const dt = moment.tz(dateTime, "Africa/Johannesburg");
      this.dateTime = dt.format("YYYY-MM-DD HH:mm:ss");
      if (this.status == "edit") {
        this.saveChanges("lesson_date_time");
      }
    },
    getSelectedValue(column) {
      if (this.status == "edit") {
        this.saveChanges(column);
      }
    },
    getValue(column) {
      this.entryEditData[column] = event.target.value;
      if (this.status == "edit") {
        this.saveChanges(column);
      }
    },
    setSelectValue(column) {
      this.selectData[column] = this.ddObj;
    },
    setBase64Img(column) {
      const file = event.target.files[0];
      const fileReader = new FileReader();

      fileReader.addEventListener("load", () => {
        this.entryEditData[column] = fileReader.result;
        if (this.status == "edit") {
          this.saveChanges(column);
        }
        this.fileLabel = this.catifyHead(column) + " IS READY!";
      });

      fileReader.readAsDataURL(file);
    },
    saveChanges(column) {
      let value = this.entryEditData[column];
      const id = this.entryEditData.id;
      const table = this.selTable;

      if (column.includes("date_time")) {
        value = this.dateTime;
      }

      const data = {
        table: table,
        id: id,
        column: column,
        value: value
      };

      axios
        .postDataWithToken("/auth/update-item", data, this.getAccessToken)
        .then(response => {
          if (response == "success") {
            this.$emit("data-updated");
          }
        });
    },
    catifyHead(value) {
      if (value.includes("_")) {
        const spArr = value.split("_");

        let newStr = "";
        for (let i = 0; i < spArr.length; i++) {
          newStr += spArr[i].toUpperCase() + " ";
        }
        return newStr;
      } else {
        const newStr = value.toUpperCase();
        return newStr;
      }
    },
    saveFormData() {
      if (this.status != "edit") {
        const keys = Object.keys(this.entryEditData);
        keys.forEach(k => {
          if (k.includes("date_time")) {
            const dateTime = moment.tz(this.dateTime, "Africa/Johannesburg");
            this.entryEditData[k] = dateTime.format("YYYY-MM-DD HH:mm:ss");
          }
        });

        axios
          .postDataWithToken(
            "/auth/save-form-data",
            {
              table: this.selTable,
              data: this.entryEditData
            },
            this.getAccessToken
          )
          .then(response => {
            if (response == "success") {
              this.$emit("data-saved");
            }
          });
      } else {
        this.$emit("data-saved");
      }
      //end of the completed
      // this.tblHeaders.forEach(column => {
      //   if (!column.endsWith("_id")) {
      //     this.myFormData[column] = $("#" + column).val();
      //   } else if (this.selectData[column] != undefined) {
      //     this.myFormData[column] = this.selectData[column];
      //   } else {
      //     this.myFormData[column] = this.entryEditData[column];
      //   }
      // });
      // const valsCheck = Object.values(this.myFormData);
      // if (valsCheck.includes(undefined)) {
      //   this.btnText = "All Fields Required!";
      //   this.btnColor = "red";
      // } else if (valsCheck.includes("")) {
      //   this.btnText = "All Fields Required!";
      //   this.btnColor = "red";
      // }
      // console.log(this.entryEditData);
      // axios
      //   .postDataWithToken(
      //     "/auth/ajax-form-data",
      //     {
      //       table: this.selTable,
      //       data: this.myFormData
      //     },
      //     this.getAccessToken
      //   )
      //   .then(response => {
      //     console.log(response);
      //   });
    }
  },

  filters: {
    catifyHead(value) {
      if (value.includes("_")) {
        const spArr = value.split("_");

        let newStr = "";
        for (let i = 0; i < spArr.length; i++) {
          newStr += spArr[i].toUpperCase() + " ";
        }
        return newStr;
      } else {
        const newStr = value.toUpperCase();
        return newStr;
      }
    }
  }
};
</script>

<style>
</style>